export default {
  addressRemoved: 'Address removed',
  addressUpdated: 'Address updated',
  addressAdded: 'Address added',
  address: 'Address'
}
